import React, { useEffect, useState } from "react";
import { Table, Typography, message } from "antd";
import { useParams } from "react-router-dom";

const { Title } = Typography;

function ManageBacklog() {

  const { projectId } = useParams();
  const [tasks, setTasks] = useState([]);

  useEffect(() => {

    const fetchTasks = async () => {

      try {

        const token = localStorage.getItem("access-token");

        const response = await fetch(
          `https://rhrmapi.up2dateinc.com/api/tasks/project/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await response.json();

        if (Array.isArray(data)) {
          setTasks(data);
        } else {
          setTasks([]);
        }

      } catch (error) {

        message.error("Failed to load tasks");

      }

    };

    fetchTasks();

  }, [projectId]);

  const columns = [
    {
      title: "SL No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project ID",
      dataIndex: "projectId",
    },
    {
      title: "Summary",
      dataIndex: "summary",
    },
    {
      title: "Reporter",
      dataIndex: "reporter",
    },
    {
      title: "Assignee",
      dataIndex: "assignee",
    },
    {
      title: "Priority",
      dataIndex: "priority",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
  ];

  return (
    <div>

      <Title level={3}>Manage Backlogs</Title>

      <Table
        columns={columns}
        dataSource={Array.isArray(tasks) ? tasks : []}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />

    </div>
  );
}

export default ManageBacklog;